// Modal credenciales temporales — se muestra tras crear un admin de asamblea
// con contraseña generada, por si el correo de bienvenida no llega.
import styles from './TempCredentialsModal.module.css';

export default function TempCredentialsModal({ credentials, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${styles.modalCredenciales}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3><i className={`fas fa-key ${styles.iconoTitulo}`} />Credenciales generadas</h3>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <div className={styles.caja}>
            <div className={styles.cajaTexto}>
              <i className={`fas fa-check-circle ${styles.iconoCaja}`} />
              El admin de asamblea ha sido creado. Se envió un correo con las credenciales.
              Guarda esta información por si el email no llegó.
            </div>
            <div className={styles.filas}>
              <div className={styles.fila}>
                <span className={styles.etiqueta}>Email:</span>
                <span className={styles.valor}>{credentials.email}</span>
              </div>
              <div className={styles.fila}>
                <span className={styles.etiqueta}>Contraseña:</span>
                <span className={styles.clave}>
                  {credentials.password}
                </span>
              </div>
            </div>
            <div className={styles.nota}>
              <i className={`fas fa-info-circle ${styles.iconoNota}`} />
              Al primer login el sistema obligará cambiar esta contraseña temporal.
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>
            <i className={`fas fa-check ${styles.iconoBoton}`} />Entendido
          </button>
        </div>
      </div>
    </div>
  );
}
